/*
Veneer
--species <string::enum> | [<Any Lumber Species>]
--core <string::enum> | ['Particle Board', 'MDF']
--coreThickness <float> | inches
--match <string::enum> | ['Sequence', 'Book', 'Slip']

--grade <boolean::switch> | ['Good 1 Side', 'Good 2 Side']

NOTE: These 2 attributes are rare, can be considered custom, ignore on reports
--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>

--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/

import { species, cut } from '@/modules/standardItems/schemas/baseFilters'
import sheetStockFilters from '@/modules/standardItems/schemas/sheetStock/filters'

export default [
  species(),
  cut(),
  ...sheetStockFilters(),
  {
    label: 'Core',
    value: 'core',
    type: 'list'
  },
  {
    label: 'Match',
    value: 'match',
    type: 'list'
  },
  {
    label: 'Core Thickness',
    value: 'coreThickness',
    type: 'range'
  },
  {
    label: 'Grade',
    value: 'grade',
    type: 'checkboxList',
    trueValue: 'Good 2 Side',
    falseValue: 'Good 1 Side'
  },
  {
    label: 'Centered',
    value: 'centered',
    type: 'checkbox'
  },
  {
    label: 'Prefinished',
    value: 'prefinished',
    type: 'checkbox'
  }
]
